import React from 'react';
import Navbar from '@/components/sections/Navbar';
import Hero from '@/components/sections/Hero';
import Nosotros from '@/components/sections/Nosotros';
import Genetica from '@/components/sections/Genetica';
import Tecnologia from '@/components/sections/Tecnologia';
import Legado from '@/components/sections/Legado';
import Contacto from '@/components/sections/Contacto';
import Footer from '@/components/sections/Footer';

export default function Home() {
  return (
    <div className="smooth-scroll">
      <Navbar />
      <main>
        <Hero />
        <Nosotros />
        <Genetica />
        <Tecnologia />
        <Legado />
        <Contacto />
      </main>
      <Footer />
    </div>
  );
}
